import React from 'react'

export default function TruncatedText({ text, maxChars = 15, fallback = '-', className = '' }) {
  const rawValue = text === null || text === undefined ? '' : String(text)
  const normalizedValue = rawValue.trim()
  const safeValue = normalizedValue.length > 0 ? rawValue : fallback

  const limit = Number.isFinite(Number(maxChars)) ? Math.max(4, Number(maxChars)) : 15
  const shouldTruncate = String(safeValue).length > limit
  const displayValue = shouldTruncate
    ? `${String(safeValue).slice(0, limit - 3).trimEnd()}...`
    : String(safeValue)

  return (
    <span className={className} title={String(safeValue)}>
      {displayValue}
    </span>
  )
}
